import FooterHeader from "./FooterHeader";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSocket } from "../../context/SocketContext";
import { matchPath, useLocation } from "react-router-dom";
import { fetchParentalStatus } from "../../redux/ApiSlice/ParentalControlSlice";

export default function Footer(props) {
    const { VideoCardHeaderIcons, isFixedDark, handleNavigate, setLocationDetectorModal, yourFeeds, deactiveIcon = false, handleRefresh, userLogin, handleInteraction } = props;
    const [activeIcon, setActiveIcon] = useState("");
    const { unreadCount } = useSocket();
    const dispatch = useDispatch();
    const { User_profile } = useSelector((state) => state.AccountProfile);
    const accessToken = useSelector((state) => state.auth?.accessToken);
    const parentalStatus = useSelector((state) => state.ParentalControl.status);
    const parentalStatusLoading = useSelector((state) => state.ParentalControl.statusLoading);
    const parentalStatusError = useSelector((state) => state.ParentalControl.statusError);
    const { pathname: path } = useLocation();

    // Reflect the parent-controlled Neighborhood toggle in the footer. The status
    // endpoint returns `neighborhood_allowed` without requiring PIN unlock, so it's
    // safe to fetch for any logged-in user; non-teen accounts just get a 403 that's
    // stored on statusError and ignored here (no toast, no retry loop — this is a
    // silent background check, not a user action).
    useEffect(() => {
        if (accessToken && !parentalStatus && !parentalStatusLoading && !parentalStatusError) {
            dispatch(fetchParentalStatus({}));
        }
    }, [accessToken, parentalStatus, parentalStatusLoading, parentalStatusError, dispatch]);

    const neighborhoodAllowed = parentalStatus?.neighborhood_allowed ?? true;
    const visibleIcons = neighborhoodAllowed
        ? VideoCardHeaderIcons
        : VideoCardHeaderIcons?.filter((item) => item.placeholder !== "Neighborhood");

    useEffect(() => {
        const isHomePath = path === "/" || Boolean(matchPath("/v/:id", path));
        const accountPaths = [
            "/account",
            "/account/saved",
            "/account/repost",
            "/account/drafts",
            "/account/liked",
            "/account/suggestion",
            "/account/private",
            "/account/settings",
        ];

        if (isHomePath) {
            setActiveIcon("Home");
        } else if (path.includes("message")) {
            setActiveIcon("Messages");
        } else if (path.includes("neighborhood")) {
            setActiveIcon("Neighborhood");
        } else if (path.includes("account")) {
            setActiveIcon(accountPaths.includes(path) ? "Account" : "");
        } else if (path.includes("settings") || path.includes("suggestion") || path.includes("private")) {
            setActiveIcon("Account");
        } else if (path.includes("othergroup")) {
            setActiveIcon("Your Friends");
        } else {
            setActiveIcon("");
        }
    }, [path]);

    const handleIconClick = (placeholder) => {
        if (User_profile?.full_address == "" && placeholder === "Neighborhood") {
            setLocationDetectorModal(true);
            return;
        }
        if (placeholder === "Home" && deactiveIcon) {
            if (typeof handleRefresh === "function") {
                handleRefresh();
            } else if (typeof handleNavigate === "function") {
                handleNavigate(placeholder);
            }
            return;
        }
        handleNavigate(placeholder);
    };

    return (
        <>
            <FooterHeader userLogin={userLogin} handleInteraction={handleInteraction} />
            <div className={`w-full flex justify-between px-3 pt-[0.2rem] pb-0.5`}>
                {visibleIcons?.map((item, index) => {
                    const isActive = deactiveIcon ? null : item.placeholder === activeIcon;
                    return (
                        <div
                            key={index}
                            onClick={() => handleIconClick(item.placeholder)}
                            className="w-10 flex flex-col justify-evenly items-center relative"
                        >
                            <div
                                className={`cursor-pointer relative 
                                    ${isActive ? "text-[#73c3f6]" : isFixedDark
                                        ? "text-white dark:text-white"
                                        : "text-white dark:text-white"
                                    } transition-colors
                                `}
                            >
                                {item.icon && item.icon}

                                {/* Notification badge for Messages icon */}
                                {unreadCount?.data?.total_unread_messages > 0 &&
                                    item.placeholder === "Messages" && (
                                        <div className="absolute -top-1.5 -right-2 bg-red-500 text-white text-[8px] font-bold rounded-full h-4 w-4 flex items-center justify-center">
                                            {unreadCount?.data?.total_unread_messages > 0 && `${unreadCount?.data?.total_unread_messages}`}
                                        </div>
                                    )
                                }
                            </div>
                            <p
                                className={`font-inter cursor-pointer text-[7.5px] whitespace-nowrap ${isActive
                                    ? "text-[#73c3f6] font-bold"
                                    : isFixedDark
                                        ? "text-white dark:text-white"
                                        : "text-white dark:text-white"
                                    } transition-colors`}
                            >
                                {item.placeholder}
                            </p>
                        </div>
                    );
                })}
            </div>
        </>
    );
}